module.exports = __webpack_public_path__ + "img/avatar0.a8998ab9.png";